const TemplateResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'templates/:templateName/:printMethod',
        apiRequestParams.defaults(),
        {
            query: {
                isArray: false,
                method: 'GET',
            },
        }
    );
};

module.exports = TemplateResource;
